import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { NavComponent } from '../navigation/nav.component';

/**
 * Where an admin lands when none of their roles opens any page — a signed-in
 * account with no roles yet. The nav beside it is empty for the same reason.
 */
@Component({
  selector: 'app-no-access',
  standalone: true,
  imports: [HeaderComponent, NavComponent],
  templateUrl: './no-access.component.html',
})
export class NoAccessComponent {}
